import React from 'react';
import { Button } from 'src/shared/components/ui/button';

type BulkOnboardButtonProps = {
    count: number;
    onClick: () => void;
};

const BulkOnboardButton = ({ count, onClick }: BulkOnboardButtonProps) => (
    <Button variant='outline' size='mini' className='h-auto self-stretch text-[13px]' onClick={onClick}>
        Onboard all missing ({count})
    </Button>
);

export default BulkOnboardButton;
